var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"timer-button",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('span',{staticClass:"timer-button__text"},[_vm._v(" "+_vm._s(_vm.$t('saleNew.timerPanel.btn')))])])}
var staticRenderFns = []

export { render, staticRenderFns }